import * as actions from './actionTypes';

export const createUberVoucher = (phoneNumber, claimId) => ({
  type: actions.CREATE_UBER_VOUCHER, phoneNumber, claimId,
});

export const createUberVoucherSuccess = () => ({
  type: actions.CREATE_UBER_VOUCHER_SUCCESS,
});

export const createUberVoucherFailed = (error) => ({
  type: actions.CREATE_UBER_VOUCHER_FAILED,
  payload: { error },
});

export const createEnterpriseRental = (claimId, policyOverride, rentalLocation, vehicleCondition, emailAddress) => ({
  type: actions.CREATE_RENTAL, claimId, policyOverride, rentalLocation, vehicleCondition, emailAddress,
});

export const createEnterpriseRentalSuccess = () => ({
  type: actions.CREATE_RENTAL_SUCCESS,
});

export const createEnterpriseRentalFailed = (error) => ({
  type: actions.CREATE_RENTAL_FAILED,
  payload: { error },
});

export const searchEnterpriseLocations = (searchCriteria) => ({
  type: actions.ENTERPRISE_SEARCH_LOCATIONS, searchCriteria,
});

export const searchEnterpriseLocationsSuccess = (data) => ({
  type: actions.ENTERPRISE_SEARCH_LOCATIONS_SUCCESS,
  payload: { data },
});

export const searchEnterpriseLocationsFailed = (error) => ({
  type: actions.ENTERPRISE_SEARCH_LOCATIONS_FAILED,
  payload: { error },
});

export const searchAudatargetVendor = (searchCriteria) => ({
  type: actions.AUDATARGET_SEARCH_VENDOR, searchCriteria,
});

export const searchAudatargetVendorSuccess = (data) => ({
  type: actions.AUDATARGET_SEARCH_VENDOR_SUCCESS,
  payload: { data },
});

export const searchAudatargetVendorFailed = (error) => ({
  type: actions.AUDATARGET_SEARCH_VENDOR_FAILED,
  payload: { error },
});

export const audatargetGetAvailibility = (searchCriteria) => ({
  type: actions.AUDATARGET_GET_AVAILABILITY, searchCriteria,
});

export const audatargetGetAvailibilitySuccess = (data) => ({
  type: actions.AUDATARGET_GET_AVAILABILITY_SUCCESS,
  payload: { data },
});

export const audatargetGetAvailibilityFailed = (error) => ({
  type: actions.AUDATARGET_GET_AVAILABILITY_FAILED,
  payload: { error },
});

export const audatargetBookAppointment = (searchCriteria) => ({
  type: actions.AUDATARGET_BOOK_APPOINTMENT, searchCriteria,
});

export const audatargetBookAppointmentSuccess = (data) => ({
  type: actions.AUDATARGET_BOOK_APPOINTMENT_SUCCESS,
  payload: { data },
});

export const audatargetBookAppointmentFailed = (error) => ({
  type: actions.AUDATARGET_BOOK_APPOINTMENT_FAILED,
  payload: { error },
});

export const clearServicesErrors = () => ({ type: actions.CLEAR_ERRORS });

export const clearServicesState = () => ({ type: actions.CLEAR_STATE });
